<template>
  <div class="panel identity_query">
    <div class="panel_body wow animate__animated animate__fadeInUp">
      <div>
        <div class="title">工业互联网标识认证查询</div>
        <div class="content">
          <div class="input_box">
            <input type="text" autocomplete="off" placeholder="请输入工业互联网标识码" v-model="code" />
          </div>
          <div class="btn" @click.stop="goPage">验证查询</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "identity_query",
  data() {
    return {
      code: "",
    };
  },
  methods: {
    goPage() {
      if (this.code) {
        window.open("https://idfactory.cn/whois/ui/searchResult?identity=" + this.code);
      } else {
        window.open("https://idfactory.cn");
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "./index.less";
</style>
